import { SerializedSmartLink } from 'fym-common/src/db/serializersTypes';
import { PublishedPageKind } from '../published/publishedPageKind';
import { findPresaveWidget } from '../presave/findPresaveWidget';

/**
 * What kind of page this is, read from the page itself.
 *
 * A pre-save block is the strongest signal — the page is about a release that
 * has not landed — and the bio link is the one page the account owns rather
 * than makes. Everything else is a release page.
 */
export function smartLinkPageKind(smartLink: SerializedSmartLink): PublishedPageKind {
  if (findPresaveWidget(smartLink) !== undefined) {
    return PublishedPageKind.presave;
  }
  return smartLink.isMainSmartLink ? PublishedPageKind.bioLink : PublishedPageKind.release;
}
